import { Component, OnInit, Input, Output } from '@angular/core';
import { PeersService } from '../../services/peers/peers.service';
import { BinaService } from '../../services/bina/bina.service';
import { DidService } from '../../services/did/did.service';

@Component({
    selector: 'app-sumary-boxes',
    templateUrl: './sumary-boxes.component.html',
    styleUrls: ['./sumary-boxes.component.scss']
})
export class SumaryBoxesComponent implements OnInit {

    @Input() user;

    public peers = [];
    public loadingPeers = true;

    public binas = [];
    public loadingBinas = true;

    public dids = [];
    public loadingDids = true;

    constructor(
        public peersService: PeersService,
        public binaService: BinaService,
        public didService: DidService
    ) { }

    ngOnInit() {
        this.getPeers();
        this.getBinnas();
        this.getDids();
    }

    getPeers() {
        this.loadingPeers = true;
        this.peersService.list().subscribe((res) => {
            this.peers = res.peers;
            this.loadingPeers = false;
        })
    }

    getBinnas() {
        this.loadingBinas = true;
        this.binaService.list().subscribe((res) => {
            this.binas = res.binas;
            this.loadingBinas = false;
        })
    }

    getDids() {
        this.loadingDids = true;
        this.didService.list().subscribe((res)=>{
            this.dids = res.dids;
            this.loadingDids = false;
        })
    }

}
